import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ThemeType } from 'services/colortheme/colortheme.service';

import { ColorThemeService } from 'services/colortheme/colortheme.service';

// #region Custom Classes

export interface SettingsDialogOptions extends MatDialogConfig {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;

    CurrentTheme?: ThemeType | null;
}

// #endregion

@Component({
    selector: 'dialog-settings-component',
    styleUrls: ['settings.dialogcomponent.scss'],
    templateUrl: 'settings.dialogcomponent.html',
})
export class SettingsDialogComponent implements OnInit {
    title: string;
    message: string;
    oktext: string;

    CurrentTheme: ThemeType | null;

    constructor(
        private dialogRef: MatDialogRef<SettingsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: SettingsDialogOptions,
        private colorThemeSvc: ColorThemeService
    ) {
        this.title = data?.TitleText || 'Settings';
        this.message = data?.MessageText || '';
        this.oktext = data?.OKText || 'OK';

        this.CurrentTheme = data?.CurrentTheme || null;
    }

    ngOnInit() {}

    OKHandler() {
        this.dialogRef.close(true);
    }

    // #region Toggle Theme

    ToggleTheme(event: MatSlideToggleChange): void {
        this.CurrentTheme = event.checked ? 'my-dark-theme' : 'my-light-theme';
        this.colorThemeSvc.SetTheme(this.CurrentTheme);
    }

    // #endregion
}
